var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.p_active?'c1_1_1act':'','c1_1_1']},[_c('p',{on:{"click":function($event){return _vm.a_act(_vm.p_id)}}},[_vm._v(_vm._s(_vm.p_title))]),_vm._v(" "),_c('i',{staticClass:"el-icon-close",staticStyle:{"float":"right","font-size":"14px","color":"#cbc","padding":"2px"},on:{"click":function($event){return _vm.a_close(_vm.p_id)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-025a5910","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/comps/c1_tab/01_menubox.vue
// module id = null
// module chunks = 